<template>
  <div class="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-shadow">
    <p class="text-sm mb-4 font-semibold">{{ priceBandInformation }}</p>
    <hr class="border-gray-300 mb-4" />
    <div
      v-for="retributionConfiguration in sortedRetributionConfigurations"
      :key="getRetributionKey(retributionConfiguration)"
      class="mb-3"
    >
      <div class="text-gray-800 text-sm mb-1">
        Contrat
        <span class="font-bold">{{ getContractDuration(retributionConfiguration) }}</span>
        à
        <span class="font-bold">{{ getFormattedPrice(retributionConfiguration) }}</span>
        <template v-if="!showManagerRetributionConfiguration">
          <span class="mx-1">—</span>
          <span>
            Je touche
            <span class="text-primary-dark font-bold">
              {{ getFormattedSellerRemuneration(retributionConfiguration) }}
            </span>
          </span>
        </template>
      </div>
      <div v-if="showManagerRetributionConfiguration" class="text-gray-800 text-sm ml-4">
        <span>
          Vendeur :
          <span class="text-primary-dark font-bold">
            {{ getFormattedSellerRemuneration(retributionConfiguration) }}
          </span>
        </span>
        <span class="mx-1">—</span>
        <span>
          Manager :
          <span class="text-primary-dark font-bold">
            {{ getFormattedManagerRemuneration(retributionConfiguration) }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice } from "@estaly/ui";

export default {
  props: {
    retributionConfigurations: {
      type: Array,
      required: true,
    },
    priceBandMin: {
      type: [Number, String],
      required: true,
    },
    priceBandMax: {
      type: [Number, String],
      required: true,
    },
    multiplicator: {
      type: Number,
      default: 0,
    },
    showManagerRetributionConfiguration: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    priceBandInformation() {
      return `Produit entre ${this.formatPrice(this.priceBandMin)} et ${this.formatPrice(this.priceBandMax - 0.01)}`;
    },

    sortedRetributionConfigurations() {
      // Sort: monthly first, then by termLength
      return [...this.retributionConfigurations].sort((a, b) => {
        if (a.monthlyBilling && !b.monthlyBilling) return -1;
        if (!a.monthlyBilling && b.monthlyBilling) return 1;
        if (a.monthlyBilling && b.monthlyBilling) return 0;
        return a.termLength - b.termLength;
      });
    },
  },

  methods: {
    formatPrice,

    getContractDuration(retributionConfiguration) {
      return retributionConfiguration.monthlyBilling
        ? "mensuel"
        : this.$t(`termLength.${retributionConfiguration.termLength}_months`);
    },

    getFormattedPrice(retributionConfiguration) {
      return this.formatPrice(retributionConfiguration.price);
    },

    getFormattedSellerRemuneration(retributionConfiguration) {
      const baseAmount = parseFloat(retributionConfiguration.sellerNetAmount) || 0;
      const multipliedAmount = baseAmount * (1 + this.multiplicator);
      return this.formatPrice(multipliedAmount);
    },

    getFormattedManagerRemuneration(retributionConfiguration) {
      const baseAmount = parseFloat(retributionConfiguration.managerNetAmount) || 0;
      const multipliedAmount = baseAmount * (1 + this.multiplicator);
      return this.formatPrice(multipliedAmount);
    },

    getRetributionKey(retributionConfiguration) {
      return retributionConfiguration.monthlyBilling ? "monthly" : `term-${retributionConfiguration.termLength}`;
    },
  },
};
</script>
